import { Fragment, useRef, useState, type MouseEvent } from 'react';
import { Cell, CellIcon, Menu, TableRow } from '@recargas-dominicanas/core/components';
import { BusinessUserApi } from '@recargas-dominicanas/core/api';
import type { IBusinessUser } from '@recargas-dominicanas/core/types';
import { MenuOption } from '../../../../components/menu-option/menu-option.component';
import { BusinessStore } from '../../../../store/businessStore';
import { BusinessUserConfirmModal } from '../business-user-confirm-modal/business-user-confirm-modal.component';
import { BusinessUserDetailsModal } from '../business-user-details-modal/business-user-details-modal.component';
import { BusinessUserEditModal } from '../business-user-edit-modal/business-user-edit-modal.component';
import { style } from './business-user-item.module.css';

interface Props {
  businessId: number;
  businessUser: IBusinessUser;
}

export function BusinessUserItem(props: Props) {

  const { businessId, businessUser } = props;

  const iconRef = useRef<HTMLDivElement>(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openResetPasswordModal, setOpenResetPasswordModal] = useState(false);
  const [openResetedPasswordModal, setOpenResetedPasswordModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  function handleOpenMenu(event?: MouseEvent<HTMLElement>) {
    setOpenMenu(state => !state);
    event?.stopPropagation();
  }

  function handleCloseMenu() {
    setOpenMenu(false);
  }

  async function handleResetPassword() {

    await BusinessUserApi.resetPassword(businessUser.id);
    await BusinessStore.fetchBusinessUsers(businessId);
    setOpenResetedPasswordModal(true);
  }

  async function handleEnable() {

    await BusinessUserApi.enable(businessUser.id);
    await BusinessStore.fetchBusinessUsers(businessId);
  }

  async function handleDisable() {

    await BusinessUserApi.disable(businessUser.id);
    await BusinessStore.fetchBusinessUsers(businessId);
  }

  async function handleDelete() {

    await BusinessUserApi.delete(businessUser.id);
    await BusinessStore.fetchBusinessUsers(businessId);
  }

  function getState() {
    if (businessUser.state === 'ACTIVATED') return { color: 'green' as const, text: 'Activo' };
    if (businessUser.state === 'DISABLED') return { color: 'gray' as const, text: 'Inactivo' };
    return { color: 'darkgray' as const, text: 'No activado' };
  }

  const state = getState();

  return (
    <Fragment>
      <TableRow style={style.tableRow} onClick={() => setOpenModal(true)}>
        <Cell text={businessUser.name}/>
        <Cell weight='medium' text={businessUser.userName}/>
        <Cell weight='medium' color={state.color} text={state.text}/>
        <CellIcon refIcon={iconRef} onClick={handleOpenMenu}/>
      </TableRow>
      <Menu
        open={openMenu}
        anchor={iconRef}
        style={style.menu}
        top={8}
        onClose={handleCloseMenu}>
        <MenuOption text='Editar' onClick={() => setOpenEditModal(true)}/>
        {businessUser.state === 'ACTIVATED' &&
          <MenuOption text='Resetear contraseña' onClick={() => setOpenResetPasswordModal(true)}/>
        }
        {businessUser.state === 'DISABLED' &&
          <MenuOption text='Activar' onClick={handleEnable}/>
        }
        {businessUser.state === 'ACTIVATED' &&
          <MenuOption text='Desactivar' onClick={handleDisable}/>
        }
        <MenuOption
          style={style.deleteMenuOption}
          text='Eliminar'
          onClick={() => setOpenDeleteModal(true)}/>
      </Menu>
      <BusinessUserDetailsModal
        open={openModal}
        title='Usuario'
        businessUser={businessUser}
        onClose={() => setOpenModal(false)}/>
      <BusinessUserDetailsModal
        open={openResetedPasswordModal}
        title='Contraseña reseteada'
        businessUser={businessUser}
        onClose={() => setOpenResetedPasswordModal(false)}/>
      <BusinessUserConfirmModal
        open={openDeleteModal}
        title='Eliminar usuario'
        description='Eliminar usuario'
        businessUser={businessUser}
        onConfirm={handleDelete}
        onClose={() => setOpenDeleteModal(false)}/>
      <BusinessUserConfirmModal
        open={openResetPasswordModal}
        title='Resetear contraseña'
        description='Resetear la contraseña del usuario'
        businessUser={businessUser}
        onConfirm={handleResetPassword}
        onClose={() => setOpenResetPasswordModal(false)}/>
      <BusinessUserEditModal
        open={openEditModal}
        businessId={businessId}
        businessUser={businessUser}
        onClose={() => setOpenEditModal(false)}/>
    </Fragment>
  );
}
